import Quantity from './quantity_';

export type QuantityType = InstanceType<typeof Quantity>;

export default Quantity;
